export const target = (name, value) => ({ target: { name, value } })

export const isFilled = (object, property) =>
  object[property] !== undefined && object[property] !== null && object[property] !== ''

export const isNotEmpty = value => value !== undefined && value !== null && value !== ''
